// extracted by mini-css-extract-plugin
export default {"base":"AdminHeader_base__zXr8m","mainDivPanel":"AdminHeader_mainDivPanel__154Xt","link":"AdminHeader_link__YPoyA"};